import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  FiAlignRight,
  FiXCircle,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import "./Navbarmenu.css";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import mailData from '../data/mailData.js';
import axios from "axios";
import { lttBaseUrl } from "../utils/Constants.js";
const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";

  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
  let adminUser = [];
  const AdminUserFilter = userData.map((user) => user.Admin === "yes" ? adminUser.push(user.Enterprise_ID) : 'Not an Admin')

  const [currentUserRole, setCurrentUserRole] = useState(
    userData.filter((item) => item.Enterprise_ID == loggedInEnterpriseId)
  );
  useEffect(() => {
    setCurrentUserRole(
      userData?.filter((item) => item.Enterprise_ID == loggedInEnterpriseId)
    );
  }, [userData]);
  const currentUser = userData?.find(
  (item) => item.Enterprise_ID === loggedInEnterpriseId
);
const hasAccess = (role) =>
  currentUser?.[role]?.toLowerCase() === "yes";
  const allowedUsersForContibution = [
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "arpita.m.singh",
    "jeevadharani.ramanan",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "varsha.a.tyagi",
    "aditya.c.soni",
    "deepali.raina",
    "ashwin.deshpande",
    "lakshay.c.gupta",
    "chandini.vardhanapu"
  ];

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const hide = () => setisMenu(false);

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
  const [temp,setTemp] = useState("");
  useEffect(()=>{
    const homeUrl = async() =>{
      const result  = await axios.get(`${lttBaseUrl}/homeUrl`)
      const {data:{Url}} = result;
      setTemp(Url)
    }
    homeUrl();
  },[]);
  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href={temp?temp:''}
                    target= "_blank"
                  >
                    
                    L&TT Home
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links home-special-link"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    <img
                      src="/images/Home/home-icon.png"
                      alt="home"
                      className="nav-home-icon"
                    />
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href="/VodafoneTalentAcademy/home#VodafoneTalentAcademy"
                  >
                    VodafoneThree Talent Academy
                  </a>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  <a
                    className="nav-links"
                    href="/VodafoneTalentAcademy/home#Roles"
                    activeClassName="is-active"
                    aria-expanded="false"
                    aria-haspopup="true"
                    tabindex="0"
                    onClick={hide}
                  >
                    Roles
                    <span>
                      <FiChevronDown />
                    </span>
                  </a>
                  <ul className={boxClassSubMenu.join(" ")}>
                    {/* {currentUserRole?.[0]?.[`Automation_Engineer`] ===
                      "yes" && ( */}
                      {hasAccess("Automation_Engineer") && (
                        <li className="sub__menus__arrows2" onClick={hide}>
                          <NavLink
                            onClick={toggleClass}
                            activeClassName="is-active"
                            className="nav-links"
                            to="/AutomationEngineer"
                          >
                            Automation Engineer
                          </NavLink>
                        </li>
                      )}
                    {/* {currentUserRole?.[0]?.[`Backend_Developer`] === "yes" && ( */}
                      {hasAccess("Backend_Developer") && (
                      <li className="sub__menus__arrows0" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/BackendDeveloper"
                        >
                          Backend Developer
                        </NavLink>
                      </li>
                    )}
                    {/* {currentUserRole?.[0]?.[`FullStack_Engineer`] === "yes" && ( */}
                      {hasAccess("FullStack_Engineer") && (
                      <li className="sub__menus__arrows1" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/FullStackEngineering"
                        >
                          Full Stack Engineer
                        </NavLink>
                      </li>
                    )}
                    {/* {currentUserRole?.[0]?.[`System_Engineer`] === "yes" && ( */}
                      {hasAccess("System_Engineer") && (
                      <li className="sub__menus__arrows1" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/SystemEngineer"
                        >
                          System Engineer
                        </NavLink>
                      </li>
                    )}
                    {/* {currentUserRole?.[0]?.[`Web_Developer`] === "yes" && (
                      <li className="sub__menus__arrows1" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/WebDeveloper"
                        >
                          Web Developer
                        </NavLink>
                      </li>
                    )} */}
                    {hasAccess("Web_Developer") && (
                      <li className="sub__menus__arrows1" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/WebDeveloper"
                        >
                          Web Developer
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href="/VodafoneTalentAcademy/home#Testimonials"
                  >
                    Testimonials
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/Dashboard`}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faq`}
                  >
                    FAQs
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/Sponsors`}
                  >
                    Sponsors
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    href={`mailto:${(window.location.href.split(".")[3]) === "staging"
                        ? `${mailData.jeevadharani_ramanan};${mailData.reshmiharidas};${mailData.ankurmishra};${mailData.arpitasingh};${mailData.umaranibattu}`
                        : `${mailData.adityacsoni};${mailData.nikhilapala};${mailData.ashwindeshpande}`
                      }`}
                  >
                    Contact Us
                  </a>
                </li>

                {adminUser.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      to={`/userMaintenance`}
                    >
                      User Maintenance
                    </NavLink>
                  </li>
                )}
                {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li
                    onClick={toggleSubmenu}
                    className="menu-item sub__menus__arrows"
                  >
                    <a
                      className="nav-links"
                      // href="/READI/home#Admin"
                      activeClassName="is-active"
                      aria-expanded="false"
                      aria-haspopup="true"
                      tabindex="0"
                      onClick={hide}
                    >
                      Admin
                      <span>
                        <FiChevronDown />
                      </span>
                    </a>
                    <ul className={boxClassSubMenu.join(" ")}>
                      <li className="sub__menus__arrows2" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to="/upload"
                        >
                          Upload
                        </NavLink>
                      </li>
                      <li className="sub__menus__arrows2" onClick={hide}>
                        <NavLink
                          className="nav-links"
                          onClick={toggleClass}
                          to={`/reviews`}
                        >
                          Feedback
                        </NavLink>
                      </li>
                      <li className="sub__menus__arrows2" onClick={hide}>
                        <NavLink
                          className="nav-links"
                          onClick={toggleClass}
                          to={`/AnalyticsPage`}
                        >
                          Analytics
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                )}
                {/* {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      to={`/admin`}
                    >
                      Admin
                    </NavLink>
                  </li>
                )} */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
